import Inputmask from "inputmask";

export class SMSConfirmWaiting {
    constructor(optionalOptions = {}) {
        this._countDownDiv = document.querySelectorAll('[data-action="countdown"]');

        if (!this._countDownDiv) {
            this.destructor();
            return true;
        }

        let resend;

        const addCountdownTimer = (countDownDiv) => {
            let waiting = countDownDiv.querySelector('.registration-form-code-repeat--waiting')
            let resend = countDownDiv.querySelector('.registration-form-code-repeat--send')

            let timeleft = 30;
            let title
            let downloadTimer = setInterval(function(){
                if(timeleft <= 0){
                    clearInterval(downloadTimer);
                    waiting.style.display = 'none';
                    resend.style.display = 'block';
                } else {
                    title = window.declOfNum(timeleft, ['секунда', 'секунды', 'секунд']);
                    waiting.querySelector("span").innerHTML = timeleft + " " + title;
                }

                timeleft -= 1;
            }, 1000);

            waiting.style.display = 'block';
            resend.style.display = 'none';
        }

        Array.from(this._countDownDiv).forEach(function(element, index, array){
            addCountdownTimer(element)

            resend = element.querySelector('.registration-form-code-repeat--send')

            resend.querySelector('a').addEventListener('click', (event) => {
                event.preventDefault()
                addCountdownTimer(element)
            })

        });
    }

    destructor() {
        this._countDownDiv = null;
    }
}

export default new SMSConfirmWaiting();
